import { render, staticRenderFns } from "./myRights.vue?vue&type=template&id=7700ba88&scoped=true&"
import script from "./myRights.vue?vue&type=script&lang=js&"
export * from "./myRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700ba88",
  null
  
)

export default component.exports